import { Input, Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'mojo-twitter-timeline',
  templateUrl: './twitter-timeline.component.html'
})
export class TwitterTimelineComponent implements OnInit {

  @Input() href: string;
  @Input() title: string;

  constructor(private router: Router) { }

  ngOnInit() {
    
  }

  private loadTwitter(): void {
    (<any>window).twttr = (((d, s, id) => {
      let js: any, fjs = d.getElementsByTagName(s)[0],
        t = (<any>window).twttr || {};
      if (d.getElementById(id)) return t;
      js = d.createElement(s);
      js.id = id;
      js.src = "https://platform.twitter.com/widgets.js";
      fjs.parentNode.insertBefore(js, fjs);

      t._e = [];
      t.ready = (f: any) => {
        t._e.push(f);
      };

      return t;
    })(document, "script", "twitter-wjs"));

    if ((<any>window).twttr.ready())
      (<any>window).twttr.widgets.load();    
  }

  ngAfterViewInit() {
    this.loadTwitter();
  }

  ngOnDestroy() {
  }


}
